import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  INK, INK_2, INK_3, LINE, LINE_2, BLUE, BLUE_T, CRITICAL, RADIUS, POPOVER_SHADOW
} from 'common/styles/listUI';

export const BellButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: ${props => (props.open ? LINE_2 : 'transparent')};
  /* The brand colour and size of the help and admin icons it sits between. */
  color: ${props => props.theme.primaryColor};
  cursor: pointer;

  svg { width: 16px; height: 16px; }
  &:hover { background: ${LINE_2}; }
`;

export const UnreadDot = styled.span`
  position: absolute;
  top: 3px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${CRITICAL};
  border: 2px solid white;
`;

export const Panel = styled.div`
  width: 340px;
  background: white;
  border: 1px solid ${LINE};
  border-radius: ${RADIUS.menu};
  box-shadow: ${POPOVER_SHADOW};
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid ${LINE};
  font-size: 13px;
  font-weight: 700;
  color: ${INK};
`;

export const AllRead = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${INK_3};
`;

export const Row = styled(Link)`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid ${LINE_2};
  color: ${INK};

  &[data-unread='true'] { background: ${BLUE_T}; }

  &:hover { background: ${LINE_2}; color: ${INK}; }
`;

export const RowText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  font-size: 12.5px;
  font-weight: 600;
`;

export const RowMeta = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: ${INK_2};
`;

export const DotSlot = styled.span`
  padding-top: 5px;
`;

export const UnreadMark = styled.span`
  flex: none;
  width: 8px;
  height: 8px;
  margin-top: 5px;
  border-radius: 50%;
  background: ${BLUE};
`;

export const PanelEmpty = styled.div`
  padding: 18px 14px;
  font-size: 12.5px;
  color: ${INK_3};
  text-align: center;
`;

export const PanelFooter = styled(Link)`
  display: block;
  padding: 10px 14px;
  font-size: 12.5px;
  font-weight: 600;
  text-align: center;
  color: ${props => props.theme.primaryColor};

  &:hover { background: ${LINE_2}; color: ${props => props.theme.primaryColor}; }
`;
